<template>
    <div>
        <h2>{{ $t("wp.whatsAppIntegrationAgreementTitle") }}</h2>
        <span>{{ $t("wp.agreementAcceptLead") }}</span>

        <p>{{ $t("wp.agreementLegalP1") }}</p>
        <p>{{ $t("wp.agreementLegalP2") }}</p>
        <p>{{ $t("wp.agreementLegalP3") }}</p>

        <div class="d-flex justify-content-end">
            <a-button type="primary" @click="agree">
                {{ $t("wp.readAndAgree") }}
            </a-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "Agreement",
    methods: {
        agree() {
            localStorage.setItem("wp-agreement-accepted", "true");
            this.$emit("agree");
        },
    },
};
</script>

<style scoped></style>
